module.exports = __webpack_public_path__ + "BMW-logo.png";